/**
 * Maps platform names → logo image paths (relative to /public).
 * Rendered with `filter: grayscale(100%)` + `mix-blend-mode: multiply`
 * so any logo appears dark/neutral on the light card backgrounds.
 */
const PLATFORM_LOGOS: Record<string, string> = {
  // ── ERP / Shop ──────────────────────────────────────────────────────────
  Shopify: '/images/external_logos/erp_shop/Shopify.com/Shopify.com_Logo_4.png',
  Shopware: '/images/external_logos/erp_shop/Shopware/Shopware_SimpleIcon.svg',
  WooCommerce: '/images/external_logos/erp_shop/WooCommerce/WooCommerce_Logo_1.png',
  Plentymarkets: '/images/external_logos/erp_shop/Plentymarkets/Plentymarkets_idShOGs3CA_1.svg',
  SAP: '/images/external_logos/erp_shop/SAP/SAP_Logo.svg',
  'SAP B1': '/images/external_logos/erp_shop/SAP/SAP_Logo.svg',
  Xentral: '/images/external_logos/erp_shop/Xentral/Xentral_Logo.svg',
  Odoo: '/images/external_logos/erp_shop/Odoo/Odoo_Logo.svg',
  JTL: '/images/external_logos/erp_shop/JTL-Software/JTL_Logo_fetched.svg',
  Billbee: '/images/external_logos/erp_shop/Billbee/Billbee_Logo_fetched.svg',
  BigCommerce: '/images/external_logos/erp_shop/BigCommerce/BigCommerce_Logo.svg',
  Magento: '/images/external_logos/erp_shop/Magento/Magento_Logo.svg',
  Wix: '/images/external_logos/erp_shop/Wix/Wix_Logo.svg',
  PrestaShop: '/images/external_logos/erp_shop/PrestaShop/PrestaShop_Logo.svg',
  Squarespace: '/images/external_logos/erp_shop/Squarespace/Squarespace_Logo.svg',
  Oracle: '/images/external_logos/erp_shop/Oracle/Oracle_Logo.svg',
  commercetools: '/images/external_logos/erp_shop/commercetools/commercetools_Logo.svg',
  Spryker: '/images/external_logos/erp_shop/Spryker/Spryker_Logo.svg',
  VTEX: '/images/external_logos/erp_shop/VTEX/VTEX_Logo.svg',
  Lightspeed: '/images/external_logos/erp_shop/Lightspeed/Lightspeed_Logo.svg',
  Gambio: '/images/external_logos/erp_shop/Gambio/Gambio_Logo.svg',
  'Dynamics 365': '/images/external_logos/erp_shop/MicrosoftDynamics/MicrosoftDynamics_Logo.svg',
  Sage: '/images/external_logos/erp_shop/Sage/Sage_Logo.svg',
  Xero: '/images/external_logos/erp_shop/Xero/Xero_Logo.svg',
  weclapp: '/images/external_logos/erp_shop/weclapp/weclapp_Logo.svg',
  DATEV: '/images/external_logos/erp_shop/DATEV/DATEV_Logo.svg',
  Bexio: '/images/external_logos/erp_shop/Bexio/Bexio_Logo.svg',

  // ── Marktplätze ─────────────────────────────────────────────────────────
  Amazon: '/images/external_logos/marketplaces/Amazon/Amazon_Logo_0.svg',
  OTTO: '/images/external_logos/marketplaces/OTTO/OTTO_idhFZ02t4h_0.png',
  Kaufland: '/images/external_logos/marketplaces/Kaufland/Kaufland_id1ve6uNZC_0.jpeg',
  eBay: '/images/external_logos/marketplaces/EBay/EBay_idQCc4O-oy_0.png',
  Mirakl: '/images/external_logos/marketplaces/Mirakl/Mirakl_idvh9J9Wvj_0.png',
  Idealo: '/images/external_logos/marketplaces/idealo/idealo_Logo.svg',
  Etsy: '/images/external_logos/marketplaces/Etsy/Etsy_Logo_1.png',
  Zalando: '/images/external_logos/marketplaces/Zalando/Zalando_Logo.svg',
  Cdiscount: '/images/external_logos/marketplaces/Cdiscount/Cdiscount_id5Xlzj8wE_1.svg',
  METRO: '/images/external_logos/marketplaces/Logo_METRO.svg',
  Allegro: '/images/external_logos/marketplaces/Allegro/Allegro_Logo_0.svg',
  Temu: '/images/external_logos/marketplaces/Temu/Temu_Logo_0.svg',
  Afterbuy: '/images/external_logos/marketplaces/Afterbuy/Afterbuy_Logo_fetched.svg',
  'Bol.com': '/images/external_logos/marketplaces/Bolcom/Bolcom_Logo.svg',
  Walmart: '/images/external_logos/marketplaces/Walmart/Walmart_Logo.svg',
  Rakuten: '/images/external_logos/marketplaces/Rakuten/Rakuten_Logo.svg',
  AliExpress: '/images/external_logos/marketplaces/AliExpress/AliExpress_Logo.svg',
  Wish: '/images/external_logos/marketplaces/Wish/Wish_Logo.svg',
  ManoMano: '/images/external_logos/marketplaces/ManoMano/ManoMano_Logo.svg',
  Decathlon: '/images/external_logos/marketplaces/Decathlon/Decathlon_Logo.svg',
  Target: '/images/external_logos/marketplaces/Target/Target_Logo.svg',
  Wayfair: '/images/external_logos/marketplaces/Wayfair/Wayfair_Logo.svg',
  'Best Buy': '/images/external_logos/marketplaces/BestBuy/BestBuy_Logo.svg',
  Newegg: '/images/external_logos/marketplaces/Newegg/Newegg_Logo.svg',
  'TikTok Shop': '/images/external_logos/marketplaces/TikTok/TikTok_Logo.svg',
  MercadoLibre: '/images/external_logos/marketplaces/MercadoLibre/MercadoLibre_Logo.svg',
  "Macy's": '/images/external_logos/marketplaces/Macys/Macys_Logo.svg',
  "Lowe's": '/images/external_logos/marketplaces/Lowes/Lowes_Logo.svg',
  Galaxus: '/images/external_logos/marketplaces/Galaxus/Galaxus_Logo.svg',
  CDON: '/images/external_logos/marketplaces/CDON/CDON_Logo.svg',
  eMAG: '/images/external_logos/marketplaces/eMAG/eMAG_Logo.svg',
  'Back Market': '/images/external_logos/marketplaces/BackMarket/BackMarket_Logo.png',
  'About You': '/images/external_logos/marketplaces/AboutYou/AboutYou_Logo.svg',
  Vinted: '/images/external_logos/marketplaces/Vinted/Vinted_Logo.svg',

  // ── CRM / Marketing ────────────────────────────────────────────────────
  Klaviyo: '/images/external_logos/crm/Klaviyo/Klaviyo_Logo.svg',
  HubSpot: '/images/external_logos/crm/HubSpot/HubSpot_Logo.svg',
  Salesforce: '/images/external_logos/crm/Salesforce/Salesforce_Logo.svg',
  Pipedrive: '/images/external_logos/crm/Pipedrive/Pipedrive_Logo.svg',
  Zendesk: '/images/external_logos/crm/Zendesk/Zendesk_Logo.svg',
  Mailchimp: '/images/external_logos/crm/Mailchimp/Mailchimp_Logo.svg',
  Zoho: '/images/external_logos/crm/Zoho/Zoho_Logo.svg',
  Intercom: '/images/external_logos/crm/Intercom/Intercom_Logo.svg',
  Brevo: '/images/external_logos/crm/Brevo/Brevo_Logo.svg',
  ActiveCampaign: '/images/external_logos/crm/ActiveCampaign/ActiveCampaign_Logo.svg',

  // ── PIM ─────────────────────────────────────────────────────────────────
  Akeneo: '/images/external_logos/pim/Akeneo/Akeneo_Logo.svg',
  Pimcore: '/images/external_logos/pim/Pimcore/Pimcore_Logo.svg',

  // ── Middleware / Feed Management ────────────────────────────────────────
  ChannelEngine: '/images/external_logos/middleware/ChannelEngine/ChannelEngine_Logo.svg',
  Channable: '/images/external_logos/middleware/Channable/Channable_Logo.svg',
  BaseLinker: '/images/external_logos/middleware/BaseLinker/BaseLinker_Logo.svg',

  // ── Shipping / Logistik ─────────────────────────────────────────────────
  DHL: '/images/external_logos/shipping/DHL/DHL_idxN0olXHn_1.svg',
  DPD: '/images/external_logos/shipping/DPD/DPD_id9sTo-S4f_0.svg',
  GLS: '/images/external_logos/shipping/GLS Group/GLS Group_idBAEh9ATt_0.svg',
  Hermes: '/images/external_logos/shipping/Hermes/Hermes_idLKEUV4A0_0.svg',
  UPS: '/images/external_logos/shipping/UPS/UPS_Logo_0.svg',
  FedEx: '/images/external_logos/shipping/FedEx/FedEx_Logo.svg',
  PostNL: '/images/external_logos/shipping/PostNL/PostNL_Logo.svg',
  InPost: '/images/external_logos/shipping/InPost/InPost_Logo.svg',
};

export default PLATFORM_LOGOS;
